import { computed } from 'vue';

import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';
import {
  hasAbleitungsrohre,
  hasDachgeschossReactive,
  hasKeller,
  hasPhotovoltaikReactive,
  hasSanierungenReactive,
  hasVorschadenElementarReactive,
  hasVorschadenFeuerBlitzReactive,
  hasVorschadenGlasReactive,
  hasVorschadenLeitungswasserReactive,
  hasVorschadenSonstigeReactive,
  hasVorschadenSturmHagelReactive,
  hasVorschaedenReactive,
  isNotMehrfamilienhaus as sharedIsNotMehrfamilienhaus,
  isPhotovoltaikMitversichertReactive,
  showVorschadenElementarReactive,
  showVorschadenGlasversicherungReactive,
} from '@/features/Sparten/woh/formConfigs/sharedRenderConditions';

export const isNotMehrfamilienhaus: ConditionalRequestDefinition = {
  if: computed(() => sharedIsNotMehrfamilienhaus.value),
  drop: ['wohneinheiten'],
};

export const hasNotKeller: ConditionalRequestDefinition = {
  if: computed(() => !hasKeller.value),
  drop: ['kellerWohnflaeche'],
};

export const hasNotAusgebautesDachgeschoss: ConditionalRequestDefinition = {
  if: computed(() => !hasDachgeschossReactive.value),
  drop: ['dachgeschossWohnflaeche'],
};

export const hasNotPhotovoltaik: ConditionalRequestDefinition = {
  if: computed(() => !hasPhotovoltaikReactive.value),
  drop: ['photovoltaik'],
};

export const photovoltaikNotMitversichern: ConditionalRequestDefinition = {
  if: computed(() => !isPhotovoltaikMitversichertReactive.value),
  drop: [
    'photovoltaik.montage',
    'photovoltaik.neuwert',
    'photovoltaik.baujahr',
    'photovoltaik.leistung',
    'photovoltaik.flaeche',
  ],
};

export const hasNoAbleitungsrohre: ConditionalRequestDefinition = {
  if: computed(() => !hasAbleitungsrohre.value),
  drop: ['ableitungsrohre.dichtheitsnachweisVorhanden'],
};

export const hasNoSanierungen: ConditionalRequestDefinition = {
  if: computed(() => !hasSanierungenReactive.value),
  drop: ['sanierungen'],
};

export const hasNoVorschaeden: ConditionalRequestDefinition = {
  if: computed(() => !hasVorschaedenReactive.value),
  drop: [
    'vorschaeden.leitungswasser',
    'vorschaeden.leitungswasserAnzahl',
    'vorschaeden.leitungswasserJahr',
    'vorschaeden.sturmHagel',
    'vorschaeden.sturmHagelAnzahl',
    'vorschaeden.sturmHagelJahr',
    'vorschaeden.feuerBlitz',
    'vorschaeden.feuerBlitzAnzahl',
    'vorschaeden.feuerBlitzJahr',
    'vorschaeden.glas',
    'vorschaeden.glasAnzahl',
    'vorschaeden.glasJahr',
    'vorschaeden.sonstige',
    'vorschaeden.sonstigeAnzahl',
  ],
};

export const hasNoElementarVorschaden: ConditionalRequestDefinition = {
  if: computed(() => !hasVorschadenElementarReactive.value),
  drop: ['vorschaeden.elementarAnzahl', 'vorschaeden.elementarJahr'],
};

export const isNoVisibleVorschadenElementar: ConditionalRequestDefinition = {
  if: computed(() => !showVorschadenElementarReactive.value),
  drop: ['vorschaeden.elementar'],
};

export const isNoVisibleVorschadenGlas: ConditionalRequestDefinition = {
  if: computed(() => !showVorschadenGlasversicherungReactive.value),
  drop: ['vorschaeden.glas'],
};

export const hasNoVorschadenLeitungswasser: ConditionalRequestDefinition = {
  if: computed(() => !hasVorschadenLeitungswasserReactive.value),
  drop: ['vorschaeden.leitungswasserJahr', 'vorschaeden.leitungswasserAnzahl'],
};

export const hasNoVorschadenSturmHagel: ConditionalRequestDefinition = {
  if: computed(() => !hasVorschadenSturmHagelReactive.value),
  drop: ['vorschaeden.sturmHagelJahr', 'vorschaeden.sturmHagelAnzahl'],
};

export const hasNoVorschadenFeuerBlitz: ConditionalRequestDefinition = {
  if: computed(() => !hasVorschadenFeuerBlitzReactive.value),
  drop: ['vorschaeden.feuerBlitzJahr', 'vorschaeden.feuerBlitzAnzahl'],
};

export const hasNoVorschadenElementar: ConditionalRequestDefinition = {
  if: computed(() => !hasVorschadenElementarReactive.value),
  drop: ['vorschaeden.elementarJahr', 'vorschaeden.elementarAnzahl'],
};

export const hasNoVorschadenGlas: ConditionalRequestDefinition = {
  if: computed(() => !hasVorschadenGlasReactive.value),
  drop: ['vorschaeden.glasJahr', 'vorschaeden.glasAnzahl'],
};

export const hasNoVorschadenSonstige: ConditionalRequestDefinition = {
  if: computed(() => !hasVorschadenSonstigeReactive.value),
  drop: ['vorschaeden.sonstigeAnzahl'],
};

export const temporaryFields: ConditionalRequestDefinition = {
  if: computed(() => true),
  drop: ['versicherungssummeType', 'temporaryInputFields'],
};

export const wohInputDehydrationDefinitions: ConditionalRequestDefinition[] = [
  isNotMehrfamilienhaus,
  hasNotKeller,
  hasNotAusgebautesDachgeschoss,
  hasNotPhotovoltaik,
  photovoltaikNotMitversichern,
  hasNoAbleitungsrohre,
  hasNoSanierungen,
  hasNoVorschaeden,
  hasNoElementarVorschaden,
  temporaryFields,
  isNoVisibleVorschadenElementar,
  isNoVisibleVorschadenGlas,
  hasNoVorschadenLeitungswasser,
  hasNoVorschadenSturmHagel,
  hasNoVorschadenFeuerBlitz,
  hasNoVorschadenElementar,
  hasNoVorschadenGlas,
  hasNoVorschadenSonstige,
];
